import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import classnames from 'classnames';
import colors from 'styles/colors';
import { useTheme } from '@mui/material';

const Svg = styled.svg`
  width: 10px;
  height: 5px;
  stroke: ${colors.secondary.deepCove};

  /* transition: stroke 0.15s cubic-bezier(0, 0, 0, 0); */
  g {
    transition: stroke 0.1s cubic-bezier(0, 0, 0, 0);
  }

  &.down {
    transform: rotate(0);
  }

  &.up {
    transform: rotate(-180deg);
  }

  &.right {
    transform: rotate(-90deg);
  }

  &.left {
    transform: rotate(90deg);
  }
`;

function Caret({ className, right, left, up, down, viewAll = false }) {
  const classes = classnames({
    [className]: !!className,
    right,
    left,
    up,
    down,
  });
  const { palette } = useTheme();

  return viewAll ? (
    <svg
      width="11"
      height="20"
      viewBox="0 0 11 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classes}
    >
      <path
        d="M2 2L9 10L2 18"
        stroke={palette.secondary.main}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ) : (
    <Svg
      viewBox="0 0 10 5"
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        stroke="inherit"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g
          transform="translate(1.000000, 1.000000)"
          stroke="inherit"
          strokeWidth="1.9152"
        >
          <polyline points="0 -4.4408921e-16 3.57142 2.85714 7.14285 -4.4408921e-16"></polyline>
        </g>
      </g>
    </Svg>
  );
}

Caret.propTypes = {
  className: PropTypes.string,
  right: PropTypes.bool,
  left: PropTypes.bool,
  up: PropTypes.bool,
  down: PropTypes.bool,
  viewAll: PropTypes.bool,
};

export default Caret;
